document.addEventListener('DOMContentLoaded', function() {
  
	const variantRadios = document.querySelectorAll('input[name="option1"]');
	if( variantRadios ) {
			
		variantRadios.forEach(radio => {
		
			radio.addEventListener('change', function () {
					
				if( this.checked ) {

						const selectedVariantId = this.value;
						const variantInventoryJsonElement = document.querySelector('[data-variantion-inventory]');
						const variantInventoryData = JSON.parse(variantInventoryJsonElement.textContent);
						const currentVariant = variantInventoryData[selectedVariantId];
						const addToCartBtn = document.querySelector('form[action*="/cart/add"] [type="submit"]');
						
						if (currentVariant) {

							if (currentVariant.inventory_policy === 'continue' && currentVariant.available) { //deny

								document.getElementById('custom-preorder-label').style.display = 'block';
								if (addToCartBtn) {
									addToCartBtn.textContent = "Pre-Order";
									// window.theme.strings.addToCart("Pre Order");
								}
							} else {
									
								document.getElementById('custom-preorder-label').style.display = 'none';
									
									if (addToCartBtn) {
										if( !currentVariant.available ) {
											addToCartBtn.textContent = window.theme.strings.backinStockText;
										} else {
											addToCartBtn.textContent = window.theme.strings.addToCartText;
									}
								}
							}
						}
					}
			});
		
		});

		const checkedVarianRadio = document.querySelector('input[name="option1"]:checked');

		if( checkedVarianRadio ) {
			checkedVarianRadio.checked = true;
			checkedVarianRadio.dispatchEvent(new Event('change', { bubbles: true }));
		}
	}
});